import React, { memo } from 'react';
import env from 'env/env';
import breadcrumbs from '../../utils/breadcrumbs';
import PageBreadcrumbs from './Breadcrumbs';

const recipeDetailsBreadcrumbs = (() => {
  const recipeBreadcrumbs = breadcrumbs();
  recipeBreadcrumbs.breadcrumbs.push(
    {
      name: 'All categories',
      path: `${env.root}/recipes/all-categories`,
    },
    {
      name: 'All recipes',
      path: `${env.root}/recipes/all-recipes`,
    },
  );
  return recipeBreadcrumbs;
})();

type RecipeBreadcrumbsProps = {
  title: string;
};

export const RecipeBreadcrumbs = memo<RecipeBreadcrumbsProps>(
  ({ title }: RecipeBreadcrumbsProps) => (
    <PageBreadcrumbs breadcrumbs={recipeDetailsBreadcrumbs} title={title} />
  ),
);
